export const TRADE_DESCRIPTION =
  'We will process your trade details and email you once your trade is approved to schedule a time to meet and complete the transaction.';

export const BUY_DESCRIPTION =
  'After entering your information you can schedule a time to meet and complete the transaction.';
